/*@ngInject*/
const UIErrorHandlerDirective = function ($uibModal, coreConstant, localization, registerableResourceConstants, modalUtil) {

    let linkFunction = function ($scope, $elm, $attrs) {

        localization.getTranslations().then(function (translations) {

            $scope.$on(coreConstant.event.HANDLE_ERROR, function (event, payload, logInfo) {
                /*
                 * Don't display an error if event.preventDefault() was called by an error handler.
                 */
                if (!event.defaultPrevented && !modalUtil.isServerDisconnectedModalDisplayed()) {
                    let title,
                        message,
                        messageKey,
                        identifier,
                        reference,
                        trace,
                        exception;

                    if (payload) {
                        title = _.get(translations, 'alert.genericErrorTitle');
                        message = payload.errorMessage;
                        messageKey = payload.errorMessageKey;
                        identifier = payload.identifier;
                        reference = payload.reference;
                        trace = payload.trace;
                        exception = _.get(translations.alert.exceptions, messageKey);

                        if (!identifier && logInfo) {
                            identifier = logInfo.timestamp;
                        }
                        if (!trace && logInfo) {
                            if (logInfo.stacktrace) {
                                trace = logInfo.stacktrace;
                            }
                            else if (logInfo.message) {
                                trace = logInfo.message;
                            }
                        }

                        // Suppress invalid registrationIdentifier errors to the user.
                        if (message !== registerableResourceConstants.INVALID_REGISTRATION_IDENTIFIER_ERROR) {
                            if (_.isNil(exception) || _.isUndefined(exception)) {
                                if (_.isNil(message) || _.isUndefined(message)) {
                                    message = _.get(translations, 'alert.genericErrorMessage');
                                }
                            } else {
                                message = exception;
                            }

                            $uibModal.open({
                                templateUrl: '/ui/modal/errorModal/errorModal.tpl.html',
                                controller: 'errorModalController',
                                backdrop: 'static',
                                windowClass: 'genericErrorModal',
                                resolve: {
                                    options: {
                                        title: title,
                                        message: message,
                                        identifier: identifier,
                                        reference: reference,
                                        trace: trace,
                                        okButtonLabel: _.get(translations, 'alert.okButtonLabel')
                                    }
                                }
                            });
                        }
                    } else {
                        $uibModal.open({
                            templateUrl: '/ui/modal/errorModal/errorModal.tpl.html',
                            controller: 'errorModalController',
                            backdrop: 'static',
                            windowClass: 'genericErrorModal',
                            resolve: {
                                options: {
                                    title: _.get(translations, 'alert.genericErrorMessage'),
                                    message: _.get(translations, 'alert.genericErrorMessage'),
                                    okButtonLabel: _.get(translations, 'alert.okButtonLabel')
                                }
                            }
                        });
                    }
                }
            });
        });
    };

    return {
        restrict: 'E',
        replace: false,
        link: linkFunction
    };
};

angular.module('umCore')
    .directive('uiErrorHandler', UIErrorHandlerDirective);
